

export const bodyPartsOptionsModel = async (functionParameters = {}) => {

  const axios = (await import(/* webpackPrefetch: true */ `axios`)).default;

  const displayAndStoreSmartboxWithPreloader = (await import(/* webpackPrefetch: true */ `../../display/displayAndStoreSmartboxWithPreloader.js`)).displayAndStoreSmartboxWithPreloader;
   
  const { appClass, isCopying, token, submissionData, modelPath, smartboxStorageName, treatmentName, sideMenuToUse } = functionParameters;
  let {url} = functionParameters;

  const smartBoxTitle = isCopying == true ? "txt1122" : treatmentName || "txt1122";

  const { preloader, smetioSmartbox, backBtnIsClicked } = await displayAndStoreSmartboxWithPreloader({ title: smartBoxTitle, smartboxStorageName });




  if( !("values" in window[smartboxStorageName]) ) window[smartboxStorageName]["values"] = {};

  const {formData} = submissionData;
  for (const key in formData) { window[smartboxStorageName]["values"][key] = formData[key]; };

  submissionData["values"] = window[smartboxStorageName]["values"];


  // console.log(`window[smartboxStorageName]["values"] is `, window[smartboxStorageName]["values"]);


  // if( !("values" in window[smartboxStorageName]) ) window[smartboxStorageName]["values"] = {};
  // window[smartboxStorageName]["values"]["whatBodyPart"] = submissionData;

  // console.log(`window[smartboxStorageName]["values"]["whatBodyPart"] is `, window[smartboxStorageName]["values"]["whoIsTreatmentFor"]);


  const previousPreloader = functionParameters.preloader;
  previousPreloader.show();

  const previousSmartbox = functionParameters.smetioSmartbox;
  previousSmartbox.hide();

  const apiEndPoint = window.apiEndPoint;
  const language = window.userLanguage;
  const sideMenuItems = window.currentSideMenuItems;


  preloader.show();

  url = url || `${apiEndPoint}/apps/${appClass.appUserInterface }/treatments/create/${language}`;

  const res = await axios.post(url, { modelPath: modelPath || "loggedInUser/treatments/whatBodyPartModel", ...submissionData}).then(async (response) => {

    let model = response.data;
        
    // console.log("model is ", model);

    // if (model.error) return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] });
    if (model.error) { backBtnIsClicked(); return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] }); };

    const {nextStep, modelPath, instructionTitle, instructionSubtitle, token, treatmentName, updateCompleted} = model;
    model = model.model;

    // if(!window[smartboxStorageName]["values"][nextStep]) window[smartboxStorageName]["values"][nextStep] = {};

    const {formData } = submissionData;
    // for (const key in formData) { window[smartboxStorageName]["values"][nextStep][key] = formData[key]; };
    for (const key in formData) { window[smartboxStorageName]["values"][key] = formData[key]; };
    if(treatmentName) window[smartboxStorageName]["values"]["treatmentName"] = treatmentName;
    submissionData["values"] = window[smartboxStorageName]["values"];

    // window[smartboxStorageName]["values"][nextStep] = submissionData["formData"];

    // console.log(` window[smartboxStorageName]["values"] is `, window[smartboxStorageName]["values"]);

    // if(window["whatBodyPartModelSmartbox"]) window["whatBodyPartModelSmartbox"].hide();

    const getCongratulationsSmartbox = (await import(/* webpackPrefetch: true */ `../../get/getCongratulationsSmartbox.js`)).getCongratulationsSmartbox;

    const newVersionOfConvertModelToInputs = (await import(/* webpackPrefetch: true */ `./../../../classes/universal_methods/newVersionOfConvertModelToInputs.js`)).newVersionOfConvertModelToInputs;
    

    // console.log("The next is ", nextStep );
    // console.log("modelPath is ", modelPath);
    // console.log("instructionTitle is ", instructionTitle);
    // console.log("instructionSubtitle is ", instructionSubtitle);
    // console.log("token is ", token);

    if(nextStep == "addToSkillset" || updateCompleted == true ) sideMenuItems[ sideMenuToUse || "treatments"].onClick();  

    if(nextStep ==  "congratutions" || updateCompleted == true){

      smetioSmartbox.close();
      return await getCongratulationsSmartbox({ txt:instructionSubtitle });

    };




    // if(updateCompleted == true){

    // };




    const confirmationInput = await newVersionOfConvertModelToInputs({
      model, 
      withSubmitButton: nextStep == "congratutions" ? false : true, 
      withFullContainerDiv: true,
      submitText: "txt38",
      doNotShowInstruction: instructionSubtitle ? false : true,
      instructionTitle: instructionTitle || "",
      instructionSubtitle: instructionSubtitle || "",
      submissionFunctionDetails: {
        // functionPath: "apps/treatments/obtainModelForWhatBodyPart",
        functionPath: `apps/treatments/bodyPartsOptionsModel`,
        functionParameters:{
          appClass, 
          preloader, 
          smetioSmartbox,
          modelPath,
          smartboxStorageName,
          token,
          treatmentName,
          isCopying,
          url,
          sideMenuToUse

        },
        // addToSubmissionData: isCopying == true ? {} : {token, treatmentName}
        addToSubmissionData: {isCopying, token, treatmentName}
      },
      showBackBtn: nextStep == "addToSkillset" || nextStep == "congratutions" ? false : true,
      onBackBtnClicked: ()=>{

        backBtnIsClicked();
        // window["bodyPartsOptionsSmartbox"].close();
        // window["whatBodyPartModelSmartbox"].show();
      }, 

    });

    const newPreloaderDisplay = preloader.render();

    const content = `
      ${newPreloaderDisplay}
      ${confirmationInput}
    `;
    preloader.hide();

    smetioSmartbox.updateContent(content);


  }).catch((error) => {

    console.log(error);
    backBtnIsClicked();
    return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

  }).finally(() => {
    preloader.hide();
      previousPreloader.hide();
  });

};
